
import { mapGetters } from 'vuex'
import SeanceCard from './SeanceCard.vue'
import { Currency } from '~/plugins/Currency'
import Modal from '@/components/Shared/Modal'
import ProductPurchaseEFT from '../PurchaseAction/ProductPurchaseEFT.vue'
import RezzervationConnection from './RezzervationConnection.vue'
import { REZERVATION_REQUEST } from '~/plugins/rezzervation'
import PaymentEFT from './PaymentEFT.vue'
import { formatter } from '~/plugins/date'
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'
export default {
  components: {
    SeanceCard,
    Modal,
    ProductPurchaseEFT,
    RezzervationConnection,
    PaymentEFT,
    InnerLoading,
  },
  watch: {
    getCustomerPackages: {
      deep: true,
      handler() {
        this.packageKey = this.packageKey + 1
      },
    },
  },
  data() {
    return {
      packageKey: 1,
      modalKey: 1,
      validPaymentsLoading: { isLoading: false, status: false },
      eftHavalePay: false,
      isLoadingPay: false,
      selectedPayment: '',
      selectedEft: null,
      purchaseAction: false,
      showEftInformation: false,
      orderNo: '',
      activePackage: {},
      alertBox: { status: false },
      iframeLink: '',
      activeRoom: {
        Id: -1,
        Processes: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      getCustomerPackages: 'seances/getCustomerPackages',
      getValidPayments: 'seances/getValidPayments',
      getUserIP: 'user/getUserIP',
      getActiveUser: 'user/getActiveUser',
      getActiveUser: 'user/getActiveUser',
      getCustomerPackageListIsLoading:
        'seances/getCustomerPackageListIsLoading',
    }),
  },
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  methods: {
    Currency,
    formatter,
    SEND_PAYMENT_TO_CUSTOMER(remoteId) {
      this.orderNo = ''
      this.iframeLink = ''
      this.showEftInformation = false
      this.alertBox.status = false
      this.isLoadingPay = true
      if (this.selectedPayment === 'iyzico')
        this.SEND_PACKAGE_TO_CUSTOMER_WITH_IYZICO(remoteId)
      if (this.selectedPayment === 'paypal')
        this.SEND_PACKAGE_TO_CUSTOMER_WITH_PAYPAL(remoteId)
      if (this.selectedPayment === 'efthavale')
        this.SEND_PACKAGE_TO_CUSTOMER_WITH_TRANSFER(remoteId)
    },
    async SEND_PACKAGE_TO_CUSTOMER_WITH_PAYPAL(remoteId) {
      const response = await REZERVATION_REQUEST(
        'Payments/PaypalCustomerPackage',
        'POST',
        {
          CustomerId: remoteId,
          IsSms: 0,
          IsEmail: 1,
          CustomerPackageId: this.activePackage.Id,
        }
      )
      if (response.message === 'OK') {
        this.alertBox = {
          status: true,
          message: `Tebrikler! Müşterinin mail adresine "${this.activePackage.Detail}" paketi satın alma linki başarıyla gönderildi.`,
          variant: 'success',
          icon: 'check-circle',
        }
      } else {
        this.alertBox = {
          status: true,
          message:
            'Müşterinin hesabına paketi ekleyemedik. Lütfen daha sonra tekrar deneyin.',
          variant: 'danger',
          icon: 'times-circle',
        }
      }
      this.isLoadingPay = false
    },
    async SEND_PACKAGE_TO_CUSTOMER_WITH_IYZICO(remoteId) {
      const response = await REZERVATION_REQUEST(
        'Payments/IyzicoCustomerPackage',
        'POST',
        {
          CustomerId: remoteId,
          IsSms: 1,
          IsEmail: 1,
          CustomerPackageId: this.activePackage.Id,
        }
      )
      if (response.message === 'OK') {
        this.iframeLink = response.data
      } else {
        this.alertBox = {
          status: true,
          message:
            'Müşterinin hesabına paketi ekleyemedik. Lütfen daha sonra tekrar deneyin.',
          variant: 'danger',
          icon: 'times-circle',
        }
      }
      this.isLoadingPay = false
    },
    async SEND_PACKAGE_TO_CUSTOMER_WITH_TRANSFER(remoteId) {
      const response = await REZERVATION_REQUEST(
        'Payments/TransferCustomerPackage',
        'POST',
        {
          CustomerId: remoteId,
          IsSms: 1,
          IsEmail: 1,
          CustomerPackageId: this.activePackage.Id,
        }
      )
      if (response.message === 'OK') {
        this.showEftInformation = true
        this.orderNo = response.data
        this.GET_PACKAGES()
        this.alertBox = {
          status: true,
          message: `Tebrikler! "${this.activePackage.Detail}" paketi hesabınıza kayıt edildi. EFT / Havale işlemleriniz tamamlandığnıda hesabınıza eklenecektir. Aşağıdan IBAN bilgilerine ulaşabilirsiniz ayrıca mail adresinize IBAN bilgilerimizi paylaştık.`,
          variant: 'success',
          icon: 'check',
        }
      } else {
        this.alertBox = {
          status: true,
          message:
            'Müşterinin hesabına paketi ekleyemedik. Lütfen daha sonra tekrar deneyin.',
          variant: 'danger',
          icon: 'cloes',
        }
      }
      this.isLoadingPay = false
    },
    async GET_VALID_PAYMENTS(pck) {
      this.modalKey = this.modalKey + 1
      this.iframeLink = ''
      this.activePackage = pck
      this.validPaymentsLoading.status = true
      this.validPaymentsLoading.isLoading = true
      this.validPaymentsLoading = await this.$store.dispatch(
        'seances/GET_VALID_PAYMENTS',
        {
          companyId:
            this.$store.getters['seances/getCompanyRezzervationInformation'].Id,
        }
      )
    },
    LISTEN_MESSAGE() {
      const vm = this
      var eventMethod = window.addEventListener
        ? 'addEventListener'
        : 'attachEvent'
      var eventer = window[eventMethod]
      var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message'
      // Listen to message from child window
      eventer(
        messageEvent,
        function (e) {
          var key = e.message ? 'message' : 'data'
          var dataString = e[key]
          let data = dataString
          try {
            data = JSON.parse(dataString)
          } catch (error) {
            data = dataString
          }
          if (data === 'rezzervation is succeed') {
            vm.GET_PACKAGES()
            vm.validPaymentsLoading.status = false
          } else if (typeof data === 'object') {
            if (data.api.message === 'OK' && data.api.result === 'OK') {
              vm.$store.dispatch('profile.seances/SEND_TO_ADD_USERS_SEANCE', {
                ...data,
                seance: vm.product,
              })
            }
          }
          //run function//
        },
        false
      )
    },
    async GET_PACKAGES_OF_CUSTOMER() {
      if (!this.getActiveUser.token) return
      await this.$store.dispatch('seances/GET_PACKAGES_OF_CUSTOMER', {
        remoteId: this.getActiveUser.remoteId,
        currency: this.getUserIP.currency,
        processes: this.product.processes,
      })
    },
    async GET_PACKAGES() {
      await this.$store.dispatch('seances/GET_CUSTOMER_PACKAGES', {
        ...this.product,
        currency: this.getUserIP.currency,
      })
      this.GET_PACKAGES_OF_CUSTOMER()
    },
  },
  async mounted() {
    this.GET_PACKAGES()
    // if (this.getCustomerPackages.length !== 0) this.activeRoom = this.getCustomerPackages[0]
    this.LISTEN_MESSAGE()
  },
}
